const state = {
  sidebarCollapse: true,
  loadingData: false,
  accountInformation: null,
  permission: '',
  datePicked: null,
  cleaningInfo: null,
  unitDetails: null,
  reservationDetails: null
};

const getters = {};

const mutations = {
  toggleSidebar(state) {
    state.sidebarCollapse = !state.sidebarCollapse;
  },

  closeSidebar(state) {
    state.sidebarCollapse = true;
  },

  showLoading(state) {
    state.loadingData = true;
  },

  hideLoading(state) {
    state.loadingData = false;
  },

  updateAccountInfo(state, account) {
    state.accountInformation = account;
  },

  updateDate(state, date) {
    state.datePicked = date;
  },

  updateCleaningInfo(state, info) {
    state.cleaningInfo = info;
  },

  updateUnitDetails(state, info) {
    state.unitDetails = info;
  },

  updateReservationDetails(state, info) {
    state.reservationDetails = info;
  }
};

const actions = {
  toggleSidebar({commit}) {
    commit('toggleSidebar');
  },

  closeSidebar({commit}) {
    commit('closeSidebar');
  },

  showLoading({commit}) {
    commit('showLoading');
  },

  hideLoading({commit}) {
    commit('hideLoading');
  },

  updateAccountInfo({commit}, account) {
    commit('updateAccountInfo', account);
  },

  updateDate({commit}, date) {
    commit('updateDate', date);
  },

  updateCleaningInfo({commit}, info) {
    commit('updateCleaningInfo', info);
  },

  updateUnitDetails({commit}, info) {
    commit('updateUnitDetails', info);
  },

  updateReservationDetails({commit}, info) {
    commit('updateReservationDetails', info);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
